import ordinal from "ordinal";

export function displayHoleOffset(holeOffset: number, groupLabel?: string) {
  return holeOffset > 0 || groupLabel
    ? groupLabel
      ? `${"Hole"} ${holeOffset + 1}${groupLabel || ""}`
      : `${ordinal(holeOffset + 1)} ${"Hole"}`
    : null;
}
